interface IIdentifiable {
  id: string
}

// A selection is 1-5 entities against a list of thousands, so a scan per id is cheaper
// than indexing the whole list on every read.
export function resolveSelection<T extends IIdentifiable>(
  ids: string[],
  live: T[],
): T[] {
  return ids
    .map(id => live.find(candidate => candidate.id === id))
    .filter(entity => !!entity)
}
